import React from 'react'
import { Carousel } from 'react-bootstrap'
import { t } from 'ttag'

const ProfileSectionMedia = ({ section }) => {
  if (!section.additional) {
    return null
  }

  if (section.additional.length == 1) {
    const s = section.additional[0]

    return (
      <img
        style={{ minHeight: '150px' }}
        width={s.width}
        height={s.height}
        className="img-responsive"
        alt={t`An image of someone performing the tasks in the occupation`}
        src={s.imageUrl}
      />
    )
  }

  const outputIf = (cond, v) => {
    return cond ? v : null
  }

  return (
    <Carousel
      prevIcon={(
        <i
          className="fas fa-chevron-left"
          aria-hidden="true"
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            textAlign: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
          }}>
        </i>
      )}
      nextIcon={(
        <i
          className="fas fa-chevron-right"
          aria-hidden="true"
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            textAlign: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
          }}>
        </i>
      )}>
      {' '}
      {section.additional.map(s => (
        <Carousel.Item key={s.id}>
          <img
            style={{ minHeight: '150px' }}
            width={s.width}
            height={s.height}
            className="img-responsive"
            src={s.imageUrl}
          />
          {outputIf(
            s.title && s.description,
            <Carousel.Caption>
              {outputIf(s.title, <h3>{s.title}</h3>)}
              {outputIf(s.description, <p>{s.description}</p>)}
            </Carousel.Caption>
          )}
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default ProfileSectionMedia
